module.exports = __webpack_public_path__ + "static/media/tailoringNaija.0dc283ff.jpg";